import product1 from '../../assets/images/product/img-1.png'
import product2 from '../../assets/images/product/img-2.png'
import product3 from '../../assets/images/product/img-3.png'
import product4 from '../../assets/images/product/img-4.png'

import company1 from '../../assets/images/companies/img-1.png';
import company2 from '../../assets/images/companies/img-2.png';
import company3 from '../../assets/images/companies/img-3.png';
import company4 from '../../assets/images/companies/img-4.png';
import company5 from '../../assets/images/companies/img-5.png';
import company6 from '../../assets/images/companies/img-6.png';
import company7 from '../../assets/images/companies/img-7.png';
import company8 from '../../assets/images/companies/img-8.png';

const productsData = [
  {
    id: 1,
    image: product1,
    name: "Full sleeve T-shirt",
    extrades: "Blue color, T-shirt",
    description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
    date: "22/05/2017",
    newprice: 240,
    islable: true,
    lable: 'Trending',
    extraimgs :[product2,product3,product4],
    shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
    category: "T-shirts",
    reviews: 132,
    shortservices:[
      { icon: "mdi-sync", value: "10 Days Replacement" },
      { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
    ],
    colorOptions: [
      { image: product2, color: "Blue" },
      { image: product3, color: "Cyan" },
      { image: product4, color: "Green" },
    ],
    specification: [
      { type: "Category", value: "T-shirt" },
      { type: "Brand", value: "Jack & Jones" },
      { type: "Color", value: "Blue" },
      { type: "Material", value: "Cotton" },
      { type: "Weight", value: "140 Gm" },
    ],
  },
  // {
  //   id: 2,
  //   image: product2,
  //   name: "Half sleeve T-shirt",
  //   extrades: "Half sleeve, T-shirt",
  //   description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
  //   date: "22/05/2017",
  //   oldprice: "$240",
  //   newprice: 225,
  //   isOffer:true,
  //   offer:25,
  //   extraimgs :[product1,product3,product4],
  //   shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
  //   category: "T-shirts",
  //   reviews: 132,
  //   shortservices:[
  //     { icon: "mdi-sync", value: "10 Days Replacement" },
  //     { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
  //   ],
  //   colorOptions: [
  //     { image: product2, color: "Blue" },
  //     { image: product3, color: "Cyan" },
  //     { image: product4, color: "Green" },
  //   ],
  //   specification: [
  //     { type: "Category", value: "T-shirt" },
  //     { type: "Brand", value: "Jack & Jones" },
  //     { type: "Color", value: "Blue" },
  //     { type: "Material", value: "Cotton" },
  //     { type: "Weight", value: "140 Gm" },
  //   ],
  // },
  // {
  //   id: 3,
  //   image: product3,
  //   name: "Hoodie (Green)",
  //   extrades: "Green color, Hoodie",
  //   description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
  //   date: "22/05/2017",
  //   oldprice: "$290",
  //   newprice: 275,
  //   islike:true,
  //   extraimgs :[product1,product2,product4],
  //   shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
  //   category: "T-shirts",
  //   reviews: 132,
  //   shortservices:[
  //     { icon: "mdi-sync", value: "10 Days Replacement" },
  //     { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
  //   ],
  //   colorOptions: [
  //     { image: product2, color: "Blue" },
  //     { image: product3, color: "Cyan" },
  //     { image: product4, color: "Green" },
  //   ],
  //   specification: [
  //     { type: "Category", value: "T-shirt" },
  //     { type: "Brand", value: "Jack & Jones" },
  //     { type: "Color", value: "Blue" },
  //     { type: "Material", value: "Cotton" },
  //     { type: "Weight", value: "140 Gm" },
  //   ],
  // },
  // {
  //   id: 4,
  //   image: product4,
  //   name: "Full sleeve T-shirt",
  //   extrades: "Blue color, T-shirt",
  //   description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
  //   date: "22/05/2017",
  //   oldprice: "$290",
  //   newprice: 275,
  //   extraimgs :[product1,product2,product3],
  //   shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
  //   category: "T-shirts",
  //   reviews: 132,
  //   shortservices:[
  //     { icon: "mdi-sync", value: "10 Days Replacement" },
  //     { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
  //   ],
  //   colorOptions: [
  //     { image: product2,color: "Blue" },
  //     { image: product3,color: "Cyan" },
  //     { image: product4,color: "Green" },
  //   ],
  //   specification: [
  //     { type: "Category", value: "T-shirt" },
  //     { type: "Brand", value: "Jack & Jones" },
  //     { type: "Color", value: "Blue" },
  //     { type: "Material", value: "Cotton" },
  //     { type: "Weight", value: "140 Gm" },
  //   ],
  // },
  // {
  //   id: 5,
  //   image: product5,
  //   name: "Hoodie (Green)",
  //   extrades: "Gray color, Hoodie",
  //   description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
  //   date: "22/05/2017",
  //   oldprice: "$290",
  //   newprice: 275,
  //   islike:true,
  //   extraimgs :[product5,product2,product3],
  //   shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
  //   category: "T-shirts",
  //   reviews: 132,
  //   shortservices:[
  //     { icon: "mdi-sync", value: "10 Days Replacement" },
  //     { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
  //   ],
  //   colorOptions: [
  //     { image: product2, color: "Blue" },
  //     { image: product3, color: "Cyan" },
  //     { image: product4, color: "Green" },
  //   ],
  //   specification: [
  //     { type: "Category", value: "T-shirt" },
  //     { type: "Brand", value: "Jack & Jones" },
  //     { type: "Color", value: "Blue" },
  //     { type: "Material", value: "Cotton" },
  //     { type: "Weight", value: "140 Gm" },
  //   ],
  // },
  // {
  //   id: 7,
  //   image: product6,
  //   name: "Full sleeve T-shirt",
  //   extrades: "Blue color, T-shirt",
  //   description: "Lorem ipsum dolor sit consec te imperdiet iaculis ipsum..",
  //   date: "22/05/2017",
  //   oldprice: "$242",
  //   newprice: 0,
  //   extraimgs :[product6,product4,product3],
  //   shortspecifications: ['Full Sleeve', 'Cotton', 'All Sizes available', '4 Different Color'],
  //   category: "T-shirts",
  //   reviews: 132,
  //   shortservices:[
  //     { icon: "mdi-sync", value: "10 Days Replacement" },
  //     { icon: "mdi-currency-usd-circle", value: "Cash on Delivery available" },
  //   ],
  //   colorOptions: [
  //     { image: product2, color: "Blue" },
  //     { image: product3, color: "Cyan" },
  //     { image: product4, color: "Green" },
  //   ],
  //   specification: [
  //     { type: "Category", value: "T-shirt" },
  //     { type: "Brand", value: "Jack & Jones" },
  //     { type: "Color", value: "Blue" },
  //     { type: "Material", value: "Cotton" },
  //     { type: "Weight", value: "140 Gm" },
  //   ],
  // },
]

const recentProducts = [
  {
    id: 1,
    img: "img7",
    name: "Wirless Headphone",
    link: "",
    rating: 4,
    oldPrice: 240,
    newPrice: 225,
  },
  {
    id: 2,
    img: "img4",
    name: "Phone patterned cases",
    link: "",
    rating: 3,
    oldPrice: 150,
    newPrice: 145,
  },
  {
    id: 3,
    img: "img6",
    name: "Phone Dark Patterned cases",
    link: "",
    rating: 4,
    oldPrice: 138,
    newPrice: 135,
  },
]

const comments = [
  {
    id: 1,
    name: "Yuvraj",
    description:
      "To an English person, it will seem like simplified English, as a skeptical Cambridge",
    date: "11 Feb, 2020",
  },
  {
    id: 2,
    name: "Krishna",
    description:
      "Everyone realizes why a new common language would be desirable",
    date: "22 Jan, 2020",
  },
  {
    id: 3,
    name: "Akash",
    description:
      "If several languages coalesce, the grammar of the resulting",
    date: "04 Jan, 2020",
  },
]

const discountData = [
  { label: "Less than 10%", value: 0 },
  { label: "10% or more", value: 10 },
  { label: "20% or more", value: 20 },
  { label: "30% or more", value: 30 },
  { label: "40% or more", value: 40 },
  { label: "50% or more", value: 50 },
]

const orders = [
  {
    id: "1",
    orderid: "#IN1572",
    orderdate: "04 Apr, 2023",
    billingname: "Poulami Das",
    total: "₹14,200",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "2",
    orderid: "#IN1571",
    orderdate: "03 Apr, 2023",
    billingname: "Joy Adhikari",
    total: "₹13,500",
    badge: "warning",
    paymentStatus: "Unpaid",
  },
  {
    id: "3",
    orderid: "#IN1570",
    orderdate: "03 Apr, 2023",
    billingname: "Ankit Verma",
    total: "₹12,000",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "4",
    orderid: "#IN1569",
    orderdate: "02 Apr, 2023",
    billingname: "Rajesh Kumar",
    total: "₹15,000",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "5",
    orderid: "#IN1568",
    orderdate: "01 Apr, 2023",
    billingname: "Anita Sharma",
    total: "₹13,200",
    badge: "danger",
    paymentStatus: "Chargeback",
  },
  {
    id: "6",
    orderid: "#IN1567",
    orderdate: "31 Mar, 2023",
    billingname: "Ankita Patel",
    total: "₹8,750",
    badge: "warning",
    paymentStatus: "Unpaid",
  },
  {
    id: "7",
    orderid: "#IN1566",
    orderdate: "30 Mar, 2023",
    billingname: "Piyush Dey",
    total: "₹9,300",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "8",
    orderid: "#IN1565",
    orderdate: "29 Mar, 2023",
    billingname: "Richa Chatterjee",
    total: "₹10,200",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "9",
    orderid: "#IN1563",
    orderdate: "28 Mar, 2023",
    billingname: "Ankit Verma",
    total: "₹11,500",
    badge: "success",
    paymentStatus: "Paid",
  },
  {
    id: "10",
    orderid: "#IN1562",
    orderdate: "28 Mar, 2023",
    billingname: "Poulami Das",
    total: "₹13,100",
    badge: "warning",
    paymentStatus: "Unpaid",
  },
  {
    id: "11",
    orderid: "#IN1561",
    orderdate: "27 Mar, 2023",
    billingname: "Yuvraj Jwala",
    total: "₹12,800",
    badge: "success",
    paymentStatus: "Paid",
  },
];


const customers = [
  {
    username: "Arjun Mehta",
    email: "arjun.mehta@gmail.com",
    phone: "+91-98765-43210",
    amount: "₹2,00,435",
    date: "05 Apr, 2023",
  },
  {
    username: "Ananya Sharma",
    email: "ananya.sharma@yahoo.com",
    phone: "+91-91234-56789",
    amount: "₹2,65,300",
    date: "04 Apr, 2023",
  },
  {
    username: "Vikram Gupta",
    email: "vikram.gupta@rediffmail.com",
    phone: "+91-97654-32109",
    amount: "₹2,13,500",
    date: "03 Apr, 2023",
  },
  {
    username: "Priya Rao",
    email: "priya.rao@gmail.com",
    phone: "+91-99887-77665",
    amount: "₹2,69,800",
    date: "02 Apr, 2023",
  },
  {
    username: "Rohit Kapoor",
    email: "rohit.kapoor@yahoo.com",
    phone: "+91-97865-55432",
    amount: "₹2,75,800",
    date: "02 Apr, 2023",
  },
  {
    username: "Kavita Patel",
    email: "kavita.patel@gmail.com",
    phone: "+91-98745-12365",
    amount: "₹2,83,600",
    date: "01 Apr, 2023",
  },
  {
    username: "Neha Verma",
    email: "neha.verma@rediffmail.com",
    phone: "+91-91827-56432",
    amount: "₹3,24,500",
    date: "31 Mar, 2023",
  },
  {
    username: "Rajiv Desai",
    email: "rajiv.desai@gmail.com",
    phone: "+91-91765-87654",
    amount: "₹3,12,500",
    date: "30 Mar, 2023",
  },
  {
    username: "Sneha Reddy",
    email: "sneha.reddy@yahoo.com",
    phone: "+91-92765-14325",
    amount: "₹2,45,600",
    date: "30 Mar, 2023",
  },
  {
    username: "Pooja Joshi",
    email: "pooja.joshi@rediffmail.com",
    phone: "+91-92654-98731",
    amount: "₹3,42,300",
    date: "29 Mar, 2023",
  },
  {
    username: "Amit Tiwari",
    email: "amit.tiwari@gmail.com",
    phone: "+91-93456-12378",
    amount: "₹3,24,500",
    date: "28 Mar, 2023",
  },
];

const products = [
  {
    id: 1,
    name: "Amit Sharma",
    position: "Accountant",
    office: "Mumbai",
    age: "33",
    startdate: "2008/11/28",
    salary: "₹12,50,000",
  },
  {
    id: 2,
    name: "Ananya Iyer",
    position: "Chief Executive Officer (CEO)",
    office: "Bengaluru",
    age: "47",
    startdate: "2009/10/09",
    salary: "₹1,20,00,000",
  },
  {
    id: 3,
    name: "Ravi Kumar",
    position: "Junior Technical Author",
    office: "Delhi",
    age: "66",
    startdate: "2009/01/12",
    salary: "₹6,80,000",
  },
  {
    id: 4,
    name: "Priya Singh",
    position: "Software Engineer",
    office: "Hyderabad",
    age: "41",
    startdate: "2012/10/13",
    salary: "₹10,40,000",
  },
  {
    id: 5,
    name: "Rahul Verma",
    position: "Software Engineer",
    office: "Pune",
    age: "28",
    startdate: "2011/06/07",
    salary: "₹15,50,000",
  },
  {
    id: 6,
    name: "Kavita Patel",
    position: "Integration Specialist",
    office: "Kolkata",
    age: "61",
    startdate: "2012/12/02",
    salary: "₹28,00,000",
  },
  {
    id: 7,
    name: "Ajay Mishra",
    position: "Software Engineer",
    office: "Bengaluru",
    age: "38",
    startdate: "2011/05/03",
    salary: "₹12,50,000",
  },
  {
    id: 8,
    name: "Sneha Reddy",
    position: "Pre-Sales Support",
    office: "Delhi",
    age: "21",
    startdate: "2011/12/12",
    salary: "₹8,00,000",
  },
  {
    id: 9,
    name: "Riya Das",
    position: "Sales Assistant",
    office: "Mumbai",
    age: "46",
    startdate: "2011/12/06",
    salary: "₹11,00,000",
  },
  {
    id: 10,
    name: "Siddharth Menon",
    position: "Senior Javascript Developer",
    office: "Chennai",
    age: "22",
    startdate: "2012/03/29",
    salary: "₹32,50,000",
  },
  {
    id: 11,
    name: "Anil Kapoor",
    position: "Regional Director",
    office: "Mumbai",
    age: "36",
    startdate: "2008/10/16",
    salary: "₹35,00,000",
  },
  {
    id: 12,
    name: "Pooja Gupta",
    position: "Javascript Developer",
    office: "Bengaluru",
    age: "39",
    startdate: "2009/09/15",
    salary: "₹15,00,000",
  },
  {
    id: 13,
    name: "Arun Mehta",
    position: "Personnel Lead",
    office: "Delhi",
    age: "35",
    startdate: "2012/09/26",
    salary: "₹16,50,000",
  },
  {
    id: 14,
    name: "Sunita Singh",
    position: "Customer Support",
    office: "Hyderabad",
    age: "27",
    startdate: "2011/01/25",
    salary: "₹8,50,000",
  },
  {
    id: 15,
    name: "Rohan Nair",
    position: "Sales Assistant",
    office: "Mumbai",
    age: "23",
    startdate: "2010/09/20",
    salary: "₹6,50,000",
  },
  {
    id: 16,
    name: "Alok Jain",
    position: "Support Engineer",
    office: "Bengaluru",
    age: "47",
    startdate: "2009/07/07",
    salary: "₹7,50,000",
  },
  {
    id: 17,
    name: "Deepak Khanna",
    position: "Chief Operating Officer (COO)",
    office: "Delhi",
    age: "48",
    startdate: "2010/03/11",
    salary: "₹60,00,000",
  },
  {
    id: 18,
    name: "Meena Sharma",
    position: "Accountant",
    office: "Jaipur",
    age: "63",
    startdate: "2011/07/25",
    salary: "₹12,75,000",
  },
  {
    id: 19,
    name: "Vikash Kumar",
    position: "Team Leader",
    office: "Bengaluru",
    age: "22",
    startdate: "2008/10/26",
    salary: "₹18,50,000",
  },
  {
    id: 20,
    name: "Nisha Aggarwal",
    position: "Developer",
    office: "Pune",
    age: "42",
    startdate: "2010/12/22",
    salary: "₹7,00,000",
  },
];


const cartData = {
  products: [
    {
      id: 1,
      img: product1,
      name: "Full sleeve T-shirt",
      color: "Blue",
      price: "240",
      data_attr: 2,
      total: 480,
    },
    {
      id: 2,
      img: product2,
      name: "Half sleeve T-shirt",
      color: "Red",
      price: "225",
      data_attr: 1,
      total: 225,
    },
    {
      id: 3,
      img: product3,
      name: "Hoodie (Green)",
      color: "Green",
      price: "275",
      data_attr: 2,
      total: 550,
    },
    {
      id: 4,
      img: product4,
      name: "Hoodie (Gray)",
      color: "Gray",
      price: "275",
      data_attr: 1,
      total: 275,
    },
  ],
  orderSummary: {
    grandTotal: "₹1,857",
    discount: "₹ 157",
    shippingCharge: "₹ 25",
    estimatedTax: "₹19.22",
    total: "₹7,00,000",
  },
}

const customerData = [
  {
    id: "1",
    customerid: "#IN1562",
    username: "Rajesh Gupta",
    phone: "9876543210",
    email: "RajeshGupta@gmail.com",
    address: "2470 MG Road, New Delhi, Delhi 110001",
    rating: "4.5",
    walletBalance: "₹45,200",
    joiningDate: "07 Oct, 2019",
  },
  {
    id: "2",
    customerid: "#IN1561",
    username: "Sumanth Reddy",
    phone: "9123456789",
    email: "SumanthReddy@gmail.com",
    address: "3755 Jubilee Hills, Hyderabad, Telangana 500033",
    rating: "4.3",
    walletBalance: "₹48,000",
    joiningDate: "06 Oct, 2019",
  },
  {
    id: "3",
    customerid: "#IN1560",
    username: "Meera Nair",
    phone: "9988776655",
    email: "MeeraNair@yahoo.in",
    address: "3632 Kochi, Kerala 682016",
    rating: "4.6",
    walletBalance: "₹52,000",
    joiningDate: "06 Oct, 2019",
  },
  {
    id: "4",
    customerid: "#IN1559",
    username: "Amitabh Roy",
    phone: "9900112233",
    email: "AmitabhRoy@gmail.com",
    address: "4401 Park Street, Kolkata, West Bengal 700016",
    rating: "4.4",
    walletBalance: "₹40,500",
    joiningDate: "05 Oct, 2019",
  },
  {
    id: "5",
    customerid: "#IN1558",
    username: "Sneha Iyer",
    phone: "9865231478",
    email: "SnehaIyer@gmail.com",
    address: "3159 Adyar, Chennai, Tamil Nadu 600020",
    rating: "4.2",
    walletBalance: "₹38,000",
    joiningDate: "04 Oct, 2019",
  },
  {
    id: "6",
    customerid: "#IN1557",
    username: "Ravi Shankar",
    phone: "9345678901",
    email: "RaviShankar@gmail.com",
    address: "4861 Koramangala, Bengaluru, Karnataka 560095",
    rating: "4.3",
    walletBalance: "₹42,800",
    joiningDate: "03 Oct, 2019",
  },
  {
    id: "7",
    customerid: "#IN1556",
    username: "Anjali Desai",
    phone: "9876231456",
    email: "AnjaliDesai@gmail.com",
    address: "1207 Ellisbridge, Ahmedabad, Gujarat 380006",
    rating: "4.5",
    walletBalance: "₹44,600",
    joiningDate: "02 Oct, 2019",
  },
  {
    id: "8",
    customerid: "#IN1555",
    username: "Vikram Singh",
    phone: "9123654780",
    email: "VikramSingh@gmail.com",
    address: "3309 Powai, Mumbai, Maharashtra 400076",
    rating: "4.4",
    walletBalance: "₹55,000",
    joiningDate: "02 Oct, 2019",
  },
];


const shops = [
  {
    id: 1,
    img: company1,
    name: "Desi Mart",
    author: "Ramesh Yadav",
    product: 86,
    balance: "₹9,45,000",
  },
  {
    id: 2,
    img: company2,
    name: "Bharat Traders",
    author: "Sunil Khurana",
    product: 72,
    balance: "₹8,10,000",
  },
  {
    id: 3,
    img: company3,
    name: "Tech World",
    author: "Ananya Chatterjee",
    product: 75,
    balance: "₹7,95,000",
  },
  {
    id: 4,
    img: company4,
    name: "Lal Bazaar",
    author: "Rajiv Bansal",
    product: 65,
    balance: "₹10,25,000",
  },
  {
    id: 5,
    img: company5,
    name: "Bazaarwala",
    author: "Pooja Nair",
    product: 82,
    balance: "₹11,50,000",
  },
  {
    id: 6,
    img: company6,
    name: "Micro India",
    author: "Vivek Patil",
    product: 71,
    balance: "₹8,70,000",
  },
  {
    id: 7,
    img: company7,
    name: "Khanna Stores",
    author: "Radhika Khanna",
    product: 66,
    balance: "₹9,35,000",
  },
  {
    id: 8,
    img: company8,
    name: "Tech India",
    author: "Arjun Mehta",
    product: 58,
    balance: "₹10,40,000",
  },
];


export {
  productsData,
  recentProducts,
  comments,
  discountData,
  orders,
  shops,
  customerData,
  cartData,
  customers,
  products
}
